import { createAction, props } from '@ngrx/store';
import { EnvironmentData, ParentMessage } from '../../../model/environment/environment-data';

export const loadJiraUiBaseUrl = createAction(
  `[Environment] Load UI Base Url for Jira Instance`,
  props<{ ifBaseUrl: string; deliveryGuid: string }>(),
);

export const setJiraUiBaseUrl = createAction(`[Environment] Set UI Base Url for Jira Instance`, props<{ jiraUiBaseUrl: string }>());
export const loadJiraUiBaseUrlError = createAction(`[Environment] Load UI Base Url for Jira Instance error`);

export const setDataFromIFrameMessage = createAction(
  `[Environment] Set data from IFrame message`,
  props<{ environmentData: ParentMessage }>(),
);
export const setDeliveryGuid = createAction(`[Environment] Set deliveryGuid`, props<{ deliveryGuid: string }>());

export const loadEnvironmentData = createAction(`[Environment] Load Environment Data`);
export const loadEnvironmentDataError = createAction(`[Environment] Load Environment Data error`);

export const setEnvironmentData = createAction(`[Environment] Set Environment Data`, props<{ environmentData: EnvironmentData }>());

export const loadEnvironmentDataForRelease = createAction(`[Environment] Load Environment Data For Release`);
export const loadEnvironmentDataForReleaseError = createAction(`[Environment] Loading of Environment Data For Release results in error`);

export const setEnvironmentDataForRelease = createAction(
  `[Environment] Set Environment Data For Release`,
  props<{ environmentData: EnvironmentData }>(),
);
